module.exports = __webpack_public_path__ + "static/img/2.ea47868.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/1/eng/2.png
// module id = ZE8q
// module chunks = 0